import { _getScalingDescriptor } from './getScalingDescriptor.js';
function _getViewportModality(viewport, volumeId, getVolume) {
    const descriptor = _getScalingDescriptor(viewport, volumeId, getVolume);
    if (!descriptor) {
        throw new Error('Invalid viewport type');
    }
    return descriptor.modality;
}
export { _getViewportModality };
